import React from 'react';

import {
  Main,
  Heading,
  Grid,
  GridItem,
  Paragraph,
  Text,
  Link,
  ContentGroup,
} from '@constellation/core';
import { useContent } from '@interstellar/react-app-content';
import { StyledLink } from 'client/components/styledLink/StyledLink';
import * as routes from 'client/routes/manifest';
import allTestIds from 'client/testIds';
import { Helmet } from 'react-helmet';

import { MortgageConditionsContent } from './MortgageConditionsPage.config';

export default function MortgageConditionsPage() {
  const { metaContent, heading, paragraph1, paragraph2, backButton } =
    useContent<MortgageConditionsContent>();
  const testIds = allTestIds.mortgageConditions;

  return (
    <Main>
      <Helmet>
        <title>{metaContent.title}</title>
      </Helmet>
      <ContentGroup marginTop="05">
        <StyledLink
          iconPosition="left"
          data-testid={testIds.backButton}
          to={routes.KnowledgeBase}
        >
          {backButton}
        </StyledLink>
        <Heading as="h1" size="s7" marginTop="05" data-testid={testIds.heading}>
          {heading}
        </Heading>
        <Grid>
          <GridItem lg={8} md={8}>
            <Paragraph data-testid={testIds.paragraph1}>
              <Text>{paragraph1.text1}</Text>
              <Link href={paragraph1.link.url} external>
                {paragraph1.link.text}
              </Link>
              <Text>{paragraph1.text2}</Text>
            </Paragraph>
            <Paragraph data-testid={testIds.paragraph2}>
              <Text>{paragraph2.text1}</Text>
              <Link href={paragraph2.link.url} external>
                {paragraph2.link.text}
              </Link>
              <Text>{paragraph2.text2}</Text>
            </Paragraph>
          </GridItem>
        </Grid>
      </ContentGroup>
    </Main>
  );
}
